import script from "./JobTypeManagePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./JobTypeManagePage.vue?vue&type=script&setup=true&lang=ts"

import "./JobTypeManagePage.vue?vue&type=style&index=0&id=2de90404&lang=scss"

const __exports__ = script;

export default __exports__